<template>
    <div class="fill-height">
        <main-navigation-drawer></main-navigation-drawer>
        <main-app-bar></main-app-bar>
        <main-content></main-content>
    </div>
</template>

<script>
    import MainNavigationDrawer from './layout/MainNavigationDrawer';
    import MainAppBar from './layout/MainAppBar';
    import MainContent from './layout/MainContent';

    export default {
        name: "MainPage.vue",

        components: {
            MainAppBar,
            MainContent,
            MainNavigationDrawer
        },

        data: () => ({}),

        mounted() {

        },
    }
</script>

<style scoped>

</style>